import styled from '@emotion/styled';

import { Input as BaseInput } from 'components/form';

export const Form = styled.div`
  width: 66%;
  padding-left: 1.07rem;
  margin-bottom: 4rem;
`;

export const FormGroup = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.07rem;
  position: relative;
  flex-wrap: wrap;

  & > label {
    font-weight: bold;
    width: 25%;
  }

  & > div {
    width: ${({ small }) => (small ? '35%' : '75%')};
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
`;

export const Input = styled(BaseInput)`
  height: 2.43rem;
`;

export const HelperText = styled.div`
  width: 100%;
  font-size: 0.9rem;
  color: #808080;
  margin-top: 0.36rem;
  margin-left: 25%;
`;

export const SkipPoNumberText = styled.div`
  width: 100%;
  font-style: italic;
  font-size: 0.9rem;
  margin-top: 1.2rem;
  margin-left: 25%;
`;

export const Error = styled.div`
  color: ${({ theme }) => theme.colors.danger};
  margin: 0 0 0.72rem 25%;
`;
